import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import textBundle from './textBundle';

import { bindActionCreators } from 'redux';
import * as SuggestActions from 'actions/suggest';

function mapLabel(key, sector) {
  const typeLabel = textBundle['TYPE'][key] || key;
  const sectorLabel = textBundle['SECTOR'][sector] || sector;

  return `${typeLabel} - ${sectorLabel}`;
}

class Result extends Component {
  static propTypes = {
    data: PropTypes.array,
    indicatorIndex: PropTypes.number,
  };

  constructor(props) {
    super(props);

    const { dispatch } = this.props;
    const actions = bindActionCreators(SuggestActions, dispatch);
    this.actions = actions;

    this.handleIndicator = this.handleIndicator.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
  }

  handleMouseDown(event, index) {
    this.actions.setSelectedIndex(index);
  }

  handleIndicator({ top, height }) {
    const { scrollNode } = this.refs;
    const visibleHeight = scrollNode.clientHeight;
    const scrollOffset = scrollNode.scrollTop;
    const lowerBound = visibleHeight - 1.25 * height + scrollOffset;
    const upperBound = 0.75 * height + scrollOffset;

    if (top > lowerBound) {
      // below
      scrollNode.scrollTop = top - 2.75 * height;
    } else if (top < upperBound) {
      // above
      scrollNode.scrollTop = top - 0.75 * height;
    }
  }

  render() {
    const { data, indicatorIndex, open, isFetching, top, left } = this.props;
    return (
      <div
        className={classNames('SuggestResult', { open })}
        style={{ left, top, position: 'absolute' }}
      >
        <div className="dropdown-wrapper">
          <ol ref="scrollNode" className="dropdown-select">
            {data.map((item, i) => {
              return (
                <Row
                  key={i}
                  item={item}
                  index={i}
                  onIndicator={this.handleIndicator}
                  handleMouseDown={this.handleMouseDown}
                  indicator={i === indicatorIndex}
                />
              );
            })}
            {!data.length && isFetching && (
              <li className="row">
                <p>Laster…</p>
              </li>
            )}
            {!data.length && !isFetching && (
              <li className="row">
                <p>Ingen treff</p>
              </li>
            )}
          </ol>
        </div>
      </div>
    );
  }
}

class Row extends Component {
  componentDidUpdate() {
    if (this.props.indicator) {
      const { node } = this.refs;
      this.props.onIndicator({
        top: node.offsetTop,
        height: node.offsetHeight,
      });
    }
  }
  render() {
    const { item, index, indicator, handleMouseDown } = this.props;

    return (
      <li
        ref="node"
        className={classNames('row', { indicator })}
        onMouseDown={event => handleMouseDown(event, index)}
      >
        <b title={item.ITEM}>{item.ITEM}</b>
        <p title={item.LONG_NAME}>{item.LONG_NAME}</p>
        <p className="weak" title={mapLabel(item.TYPE, item.SECTOR)}>
          {mapLabel(item.TYPE, item.SECTOR)}
        </p>
      </li>
    );
  }
}

function mapStateToProps(state) {
  return state.suggest;
}

export default connect(mapStateToProps)(Result);
